<template>
	<div id="enterprise_detail">
		<leftnav class="fl" :title="companyinfor.title"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage" :data-type="userdata.userType">
				<div class="enterprise_detail">
					<div class="whitebox centerpage">
						<div class="d_blocktitle">
							<i class="title-icon title-icon1"></i>
							<h3 class="ctitle">{{companyinfor.title}}</h3> 
							<span :class="companyinfor.status == '注销'?'fl companystatus cancellation':'fl companystatus '">{{companyinfor.status}}</span>
							<!-- <span :class="companyinfor.collectId == 0?'collectbtn add fr':'collectbtn remove fr'" @click="collectFun()" v-if="userdata.operatList.jrmbqy.btn">{{companyinfor.collectId == 0?'加入目标企业':'移出目标企业'}}</span>
							<span :class="addCRMid == 0?'collectbtn add fr':'collectbtn remove fr'" @click="addtoCRM();" v-if="userdata.operatList.jrxmgl.btn">{{addCRMid == 0?'加入项目管理':'移出项目管理'}}</span>
							<div class="fr" v-show="!enterprisedata1.unlock &&!lock" v-if="userdata.operatList.xzbg.btn">
								<span class="fl enterprise-download graynocur" title="解锁后下载报告"><i class="el-icon-lock"></i>下载报告</span><span @click="pagelockfun" class="fl enterprise-lockbtn"><i class="el-icon-key"></i>解锁</span>
							</div>
							<span v-show="enterprisedata1.unlock || lock" @click="download" 	v-if="userdata.operatList.xzbg.btn" :class="{'fr enterprise-download':true,'graynocur':!iframestus}"><i class="el-icon-download"></i>{{iframestus?'下载报告':'下载中...'}}</span>
							<div class="tipspopbox_bg" v-show="unlock">
								<div class="tipspopbox_acoc">
									<h4 class="numtips">目前剩余可解锁次数：<span class="num">{{enterprisedata1.unlockRemainder}}</span></h4>
									<strong class="bluetips db">升级至正式版可获得全部访问权限</strong>
									<div class="btnbox">
										<span class="basebtn fl" @click="unlockfun()"><i class="loadingimg" v-show="lockopen"></i>{{lockbtnfont}}</span>
										<span class="graybtn fr" @click="unlock=false">取消</span>
									</div>
									<span class="closebtn" @click="unlock=false"></span>
								</div>
							</div> -->
						</div>
						<p class="companyinfor oh">
							<span class="fl"><i>注册资本：</i><em>{{companyinfor.regCapital}}</em> </span>
							<span class="fl"><i>组织机构代码：</i><em>{{companyinfor.orgCode}}</em></span>
							<span 	class="fl"><i>员工人数：</i><em>{{companyinfor.insurePerson>0?companyinfor.insurePerson:'-'}}</em>
							</span>
						</p>
						<p class="companyinfor oneline">
							<span class="fl"><i>企业类型：</i><em>{{companyinfor.type}}</em> </span>
						</p>
						<p class="companyinfor oh">
							<span class="fl"><i>注册号：</i><em>{{companyinfor.regNo}}</em> </span>
							<span class="fl"><i>纳税人识别号：</i><em>{{companyinfor.taxNo}}</em> </span>
							<span class="fl"><i>所属行业：</i><em>{{companyinfor.industry}}</em> </span>
						</p>
						<p class="companyinfor oh" v-if="realController.length>0">
							<span class="fl"><i
									style="font-size:14px ;">疑似实际控制人：</i><em>{{realController[0].title}}</em></span>
							<span class="fl"><i>总股权比例：</i><em>{{realController[0].proportion}}</em></span>
						</p>
						<div class="hidelongfont" v-if="companyinfor.businessScope!=''">
							<p class="companyinfor oneline">
								<i>经营范围：</i><em><b :key="num"  v-for="(font,num) in companyinfor.businessScope" 	v-show="num <= businfontnum">{{font}}</b>
									<b :class="businfontnum > defaultmainnum?'dn':''">……</b><b class="xqbtn curp" 	@click="editfontnum('busin')">{{businfontnum > defaultmainnum?'收起':'详情'}}</b></em>
							</p>
						</div> 
					</div>
					<div class="de_floorlist1 ende_floorlist" style="width:100%">
						<div class="ende_floorlistfixed" :style="isCollapse?'width:100%;left:0':''">
							<ul class="oh">
								<li class="floorlistLi" @click="floorscroll(0)">联系方式</li>
								<li class="floorlistLi" @click="floorscroll(1)" v-show="changeLog.length>0">变更记录</li> 
								<li class="floorlistLi" @click="floorscroll(2)" v-show="technologyList.length>0">企业资质</li>
								<li class="floorlistLi" @click="floorscroll(3)" v-show="investlist.length>0">对外投资</li> 
								<li class="floorlistLi" @click="floorscroll(4)" v-show="controllEnterprise.length>0">控制企业</li>
								<li class="floorlistLi" @click="floorscroll(4)" v-show="relationship.length>0">疑似关系</li>
								<li class="floorlistLi" @click="floorscroll(6)" v-show="shareholderlist.length>0">股东信息</li>
								<li class="floorlistLi" @click="floorscroll(7)" v-show="patentlist.length>0 || companyinfor.patentNum>0">专利信息</li>
								<li class="floorlistLi" @click="floorscroll(8)" v-show="softwareList.length>0">软件著作权</li>
								<li class="floorlistLi" @click="floorscroll(9)" v-show="certificatelist.length>0">资质证书</li> 
							</ul>
						</div>
					</div>
					<!-- 联系方式 -->
					<div class="whitebox company-contact	centerpage">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon2"></i>
							<h3 class="title">联系方式</h3>
						</div>
						<p class="companyinfor oh">
							<span class="fl"><i>法定代表人：</i><em>{{companyinfor.legalPerson}}</em> </span>
							<span class="fl"><i>联系电话：</i><em>{{companyinfor.phone}}</em> </span>
							<span class="fl"><i>更多电话：</i><em>{{companyinfor.morePhone}}</em>
							</span>
						</p>
						<div class="enprise_websitebox" v-show="rwebsite" @click="rwebsite=false">
							<div class="enprise_website">
								<h2>您即将跳转进入第三方网站</h2>
								<p class="website_tips"><b>产业大脑</b>不对该网站内容及真实性负责，请注意您的账户和财产安全</p>
								<p class="website_text">{{companyinfor.website}}</p>
								<span class="router_website" @click="geturl(companyinfor.website)">继续前往</span>
							</div>
						</div>
						<p class="companyinfor oh">
							<span class="fl com_website"><i>网 址：</i>
								<em class="curp" 	@click="rwebsite=true">{{companyinfor.website}}</em> 
							</span> 
							<span class="fl"><i>联系邮箱：</i><em>{{companyinfor.email}}</em> </span>
							<span class="fl"><i>更多邮箱：</i><em>{{companyinfor.moreEmail}}</em> </span>
						</p>
						<p class="companyinfor oneline">
							<i>企业地址：</i><em>{{companyinfor.address}}</em>
						</p>
					</div>
					<!--变更记录  -->
					<div class="whitebox company-investinfor" v-show="changeLog.length>0">
						<div class="d_blocktitle d-floortitle">
							<i class="title-icon title-icon7"></i>
							<h3 class="title">变更记录</h3>
						</div> 
						<h4 class="endsm_title w95mg">迁址记录</h4> 
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>变更日期</th>
								<th>变更项目</th>
								<th>变更前</th>
								<th>变更后</th> 
							</tr>
							<tr   :key="i"  v-for="(list,i) in changeLog">
								<td>{{i+1}}</td>
								<td>{{list.date}}</td>
								<td>{{list.type}} </td>
								<td>{{list.changeBefore}}</td>
								<td>{{list.changeAfter}}</td> 
							</tr> 
						</table>  
					</div>
					<!--企业资质  -->
				<div class="whitebox company-investinfor centerpage" v-show="technologyList.length>0">
					<div class=" d_blocktitle d-floortitle">
						<i class="title-icon title-icon6"></i>
						<h3 class="title">科技型企业资质</h3>
					</div> 
					<table border="0" cellspacing="0" cellpadding="0" width="100%" class="pagetable1 w95mg">
						<tr>
							<th class="xuhaotd">序号</th>
							<th>名称</th>
							<th>编号</th>
							<th>资质类型</th>
							<th>级别</th>
							<th>来源</th> 
							<th>发布单位</th> 
							<th>发布日期</th> 
							<th>有效期自</th> 
							<th>有效期至</th> 
						</tr>
						<tr :key="index"  v-for="(item,index) in technologyList">
							<td>{{index+1}}</td>
							<td>{{item.title}}</td>
							<td>{{item.number}}</td>
							<td>{{item.qualificationType}}</td>
							<td>{{item.level}}</td>
							<td>{{item.source}}</td>
							<td>{{item.publishUnit}}</td>
							<td>{{item.publishDate}}</td>
							<td>{{item.validFrom}}</td>
							<td>{{item.validTo}}</td> 
						</tr>
					</table>  
				</div>
					<!-- 对外投资 -->
					<div class="whitebox company-investinfor centerpage" v-show="investlist.length>0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon8"></i>
							<h3 class="title">对外投资</h3>
						</div>  
						<p style="margin-bottom: 10px;"  class="w95mg"><b class="orange_font">{{companyinfor.title}}</b>共有对外投资<b class="orange_font">{{investlist.length}}</b>个。</p>
						<div class="locktable w95mg" >
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1" width="100%">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>被投资企业名称</th>
									<th>法定代表人</th>
									<th>注册资本</th>
									<th>投资比例</th>
									<th>投资数额</th>
									<th>成立时间</th>
									<th>状态</th>
								</tr>
								<tr :key="index"  v-for="(item,index) in investlist" >
									<td>{{index+1}}</td>
									<td>
										<span @click="detailrouterto('/enterprises',item.stockCode)" :class="item.stockCode != '' ? 'curp':''" :data="item.stockCode">{{item.title}}</span>
									</td>
									<td>{{item.legalPerson}}</td>
									<td>{{item.regCapital}}</td>
									<td>{{item.proportion}}%</td>
									<td>{{item.investAmount}}</td>
									<td>{{item.createTime}}</td>
									<td>{{item.status}}</td>
								</tr> 
							</table>  
						</div>  
					</div>
				 <!-- 控制企业 -->
				<div class="whitebox company-investinfor centerpage" v-show="controllEnterprise.length>0">
					<div class=" d_blocktitle d-floortitle">
						<i class="title-icon title-icon8"></i>
						<h3 class="title">控制企业</h3>
					</div>
					<p style="margin-bottom: 10px;" class="w95mg" v-if="controllEnterprise.length>0"><b class="orange_font">{{companyinfor.title}}</b>共有控制企业<b class="orange_font">{{controllEnterprise.length}}</b>个</p>
					<div class="locktable w95mg" > 
						<table border="0" cellspacing="0" cellpadding="0" class="pagetable1">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>控制企业</th>
								<th>投资比例</th>
								<th>投资链</th> 
							</tr>
							<tr :key="index"  v-for="(item,index) in controllEnterprise" v-if="index<10">
								<td>{{index+1}}</td>
								<td>
									<span @click="detailrouterto('/enterprises',item.stockCode)" :class="item.stockCode != '' ? 'curp':''" :data="item.stockCode" style="white-space: nowrap;display: block;">{{item.title}}</span>
								</td>
								<td><span >{{item.proportion}}</span></td>
								<td>
									<span :key="num" v-for="(texts,num) in item.investChainhtml" class="db tal" v-if="texts!=''" v-html="texts"></span>
								</td> 
							</tr> 
						</table>
						<p class="lockfont" v-show="controllEnterprise.length>10">点击&nbsp;<span class="basefont fontb"  @click="pagelockfun"><i class="el-icon-key"></i>解锁</span>&nbsp;查看完整信息</p>
					</div> 
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1" >
							<tr>
								<th class="xuhaotd">序号</th>
								<th>控制企业</th>
								<th>投资比例</th>
								<th>投资链</th> 
							</tr>
							<tr :key="index"  v-for="(item,index) in controllEnterprise">
								<td>{{index+1}}</td>
								<td>
									<span @click="detailrouterto('/enterprises',item.stockCode)" :class="item.stockCode != '' ? 'curp':''" :data="item.stockCode" style="white-space: nowrap;display: block;">{{item.title}}</span>
								</td>
								<td><span >{{item.proportion}}</span></td>
								<td>
									<span :key="num" v-for="(texts,num) in item.investChainhtml" class="db tal" v-if="texts!=''" v-html="texts"></span>
								</td> 
							</tr> 
						</table> 
					</div> 
				<!-- 疑似关系 -->
				<div class="whitebox company-investinfor" v-show="relationship.length>0">
					<div class="d_blocktitle d-floortitle">
						<i class="title-icon "></i>
						<h3 class="title">疑似关系</h3>
					</div>  
					<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
						<tr>
							<th class="xuhaotd">序号</th>
							<th>企业名称</th>
							<th>地区</th>
							<th>法定代表人</th>
							<th>注册资本</th>
							<th>成立日期</th> 
							<th>疑似关系类型</th> 
							<th>疑似关系详情</th>  
						</tr>
						<tr   :key="i"  v-for="(list,i) in relationship">
							<td>{{i+1}}</td>
							<td><span v-if="list.stockCode == ''">{{list.title}}</span><span class="curp" v-if="list.stockCode != ''" @click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</span></td>
							<td>{{emptyStr(list.area)}}</td>
							<td>{{list.legalPerson}}</td>
							<td>{{list.regCapital}}</td>
							<td>{{list.createTime}}</td>
							<td>{{list.type}}</td>
							<td>{{list.detail}}</td> 
						</tr> 
					</table> 
				</div>
				<!-- 股东信息 -->
				<div class="whitebox company-investinfor centerpage" v-show="shareholderlist.length>0">
					<div class=" d_blocktitle d-floortitle">
						<i class="title-icon title-icon4"></i>
						<h3 class="title">股东信息</h3>
					</div>
					<p style="margin-bottom: 10px;" class="w95mg" v-if="shareholderlist.length>0">共<b class="orange_font">{{shareholderlist.length}}</b>位股东，最大的股东是<b class="orange_font">{{shareholderlist[0].name}}</b>，持股比例为<b class="orange_font">{{shareholderlist[0].value}}%</b>。</p>
					<div class="w95mg flexcss">
					<table border="0" cellspacing="0" cellpadding="0" width="50%" class="pagetable1 gdxx-h">
						<tr>
							<th class="xuhaotd">序号</th>
							<th>股东及出资信息</th>
							<th>持股比例</th>
							<th>持股数(股)</th>
						</tr>
						<tr :key="index"  v-for="(item,index) in shareholderlist">
							<td>{{index+1}}</td>
							<td><span @click="detailrouterto('/enterprises',item.stockCode)" :class="item.stockCode != '' ? 'curp':''" :data="item.stockCode">{{item.name}}</span></td>
							<td>{{item.value}}%</td>
							<td>{{item.number}}</td>
						</tr>
					</table>
					<div class="" id="detail_sharholder" style="width: 48%;"></div> 
					<p style="clear: both;" v-show="companyinfor.isIpo">注：上市公司的小比例投资机构、散户投资者在表中不显示，故上表持股比例和低于100%。</p>
					</div>
				</div>
				<!-- 最新专利 -->
				<div class="whitebox company-investinfor centerpage" v-show="patentlist.length>0">
					<div class=" d_blocktitle d-floortitle">
						<i class="title-icon title-icon6"></i>
						<h3 class="title">最新专利</h3>
					</div>
					<div class="oh" style="margin-bottom: 30px;" v-show="companyinfor.patentNum>0">
						<p class="companyinforN oh companyinfor5"> 
							<span class="fl"><i>专利量：</i><em>{{companyinfor.patentNum}}</em></span> 
							<span class="fl"><i>发明（设计）人数量：</i><em>{{companyinfor.inventionNum}}</em></span> 
							<span class="fl"><i>有效专利量：</i><em>{{companyinfor.validPatentNum}}</em></span> 
							<span class="fl"><i>有效发明专利数量（件）：</i><em>{{companyinfor.validInventionNum}}</em></span> 
							<span class="fl"><i>有效实用新型数量（件）：</i><em>{{companyinfor.validPracticalNewTypeNum}}</em></span> 
						</p>
						<p class="companyinforN oh companyinfor5"> 
							<span class="fl"><i>有效外观设计数量（件）：</i><em>{{companyinfor.validFacadeDesignNum}}</em></span> 
							<span class="fl"><i>发明公开专利总量：</i><em>{{companyinfor.inventionPublicPatentNum}}</em></span> 
							<span class="fl"><i>外观设计专利总量：</i><em>{{companyinfor.facadeDesignPatentNum}}</em></span> 
							<span class="fl"><i>实用新型专利总量：</i><em>{{companyinfor.practicalNewTypePatentCount}}</em></span> 
						</p> 
					</div> 
					<div :class="showzhuanlinum<patentlist.length?'demandlist_hide_table showmorenode':'demandlist_hide_table'" >
						<!--  -->
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>发明名称</th>
								<th>专利类型</th>
								<th>法律状态</th>
								<th>申请号</th>
								<th>申请日</th>
								<th>公开(公告)号</th>
								<th>公开(公告)日期</th>
								<th>发明人</th>
							</tr>
							<tr :key="index"  v-for="(item,index) in patentlist" v-if="index < showzhuanlinum">
								<td>{{index+1}}</td>
								<td>{{item.title}}</td>
								<td>{{item.type}}</td>
								<td>{{item.legalStatus}}</td>
								<td>{{item.pubNo}}</td>
								<td>{{item.appDate}}</td>
								<td>{{item.appNo}}</td>
								<td>{{item.pubDate}}</td>
								<td>{{item.inventor}}</td>
							</tr>
						</table>
						<div class="showmorenodebtn" @click="contorlpatent('zl')" v-show="patentlist.length>100 && enterprisedata1.unlock">
							<span v-show="showzhuanlinum>=patentlist.length">向上隐藏</span>
							<span v-show="showzhuanlinum<patentlist.length">共{{patentlist.length}}条信息 点击加载更多>></span>
						</div> 
					</div>  
				</div>
				<!--软件著作权  -->
				<div class="whitebox company-investinfor centerpage" v-show="softwareList.length>0">
					<div class=" d_blocktitle d-floortitle">
						<i class="title-icon title-icon6"></i>
						<h3 class="title">软件著作权</h3>
					</div> 
					<table border="0" cellspacing="0" cellpadding="0"  class="pagetable1 w95mg">
						<tr>
							<th class="xuhaotd">序号</th>
							<th>软件全称</th>
							<th>版本号</th>
							<th>登记号</th>
							<th>开发完成日期</th>
							<th>首次发布日期</th> 
							<th>登记日期</th> 
							<th>权力取得方式</th>  
						</tr>
						<tr :key="index"  v-for="(item,index) in softwareList">
							<td>{{index+1}}</td>
							<td>{{item.title}}</td>
							<td>{{item.version}}</td>
							<td>{{item.regNo}}</td>
							<td>{{item.completeDate}}</td>
							<td>{{item.publishDate}}</td>
							<td>{{item.regDate}}</td>
							<td>{{item.authType}}</td> 
						</tr>
					</table>  
				</div>
				<!-- 资质证书 -->
				<div class="whitebox company-investinfor centerpage" v-show="certificatelist.length>0">
					<div class=" d_blocktitle d-floortitle">
						<i class="title-icon title-icon5"></i>
						<h3 class="title">资质证书</h3>
					</div>
					<p class="w95mg" style="margin-bottom: 10px;"><b class="orange_font">{{companyinfor.title}}</b>拥有资质证书共<b class="orange_font">{{certificatelist.length}}</b>种。</p>
					<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
						<tr>
							<th class="xuhaotd">序号</th>
							<th>证书类型</th>
							<th>证书名称</th>
							<th>证书编号</th>
							<th>发证日期</th>
							<th>截止日期</th>
						</tr>
						<tr :key="index"  v-for="(item,index) in certificatelist">
							<td>{{index+1}}</td>
							<td>{{item.certType}}</td>
							<td class="toolongtd">{{item.certName}}</td>
							<td>{{item.certNo}}</td>
							<td>{{item.startDate}}</td>
							<td>{{item.endDate}}</td>
						</tr>
					</table> 
				</div>  
			</div>
		</div>
	</div>

	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'enterpriseYqSim',//域内招商园区企业详情页简化版
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: '园区招商企业详情页',
				enterpriseid: 300750,
				userdata: {},
				//页面信息-文字头部信息
				enterprisedata1: {},
				addCRMid:0, 
				lockopen:false, 
				lockbtnfont:'确定解锁',
				unlock:false,//解锁下载报告弹框
				lock:false, //下载报告按钮是否上锁
				iframeurl:'',
				iframestus:true,
				iframestus1:true,
				businfontnum:60,
				defaultmainnum:60,
				showzhuanlinum:100, 
				showzhuanlibtn:1,
				extendinfor: {}, 
				companyinfor: {
					title:'',
					tag: "测试文字",
					name: "雪松大厦",
					collectId: 0,
					collectType: 20,
					num: 80,
				},
				realController: [],//实际控制人
				investlist:[],//对外投资列表
				controllEnterprise:[],//控制企业
				shareholderlist:[],//股东信息
				patentlist:[],//最新专利
				certificatelist:[],//资质证书
				softwareList:[],//软件著作权
				technologyList:[],//企业资质
				relationship:[],//疑似关系
				changeLog:[],//变更记录
				rwebsite: false, // 机构网页跳转提示框
				//常用配置
				echartWidth2: document.body.offsetWidth * 0.8728 * 0.95 * 0.48,
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"],
				barHeight: 60,

			}
		},
		beforeCreate() {

		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			// window.scrollTo(0,0);
			// this.bus.$emit('loading',true);
			this.enterpriseid = this.$route.query.id ?this.$route.query.id : 300750;
			var _this = this;
			this.getuserinfor(); 
			this.getenterdetail(1);
			this.getenterdetail(2); 
		},
		mounted() {
			window.scrollTo(0, 0);
			window.addEventListener("scroll", this.handleScroll, true);
		},
		methods: {
			getenterdetail(step) {
				var _this = this;
				var ajaxurl = this.$api.park.enterprise.detail();
				if (step == 2) { 
					ajaxurl = this.$api.park.enterprise.detail2();
				}
				this.$axios.get(ajaxurl + "?stockCode=" + this.enterpriseid, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log(res.data)
					console.log('第' + step + '部分信息', res);
					if (res.data.success) {
						if (step == 1) { 
							_this.companyinfor = res.data.data;
							document.title = res.data.data.title; 
							_this.isExist();
							
							setTimeout(function() {
								_this.bus.$emit('loading', false);
							}, 2600); 
						} else if (step == 2) {
							// _this.realController = res.data.data.realController; //实际控制人 
							_this.investlist=res.data.data.invest;//对外投资信息
							// _this.controllEnterprisefun(res.data.data.controllEnterprise);//控制企业
							_this.shareholderlist=res.data.data.shareholder;//股东信息
							_this.patentlist=res.data.data.patent;//发明专利信息 
							_this.certificatelist=res.data.data.certificate;//资质证书 
							_this.softwareList=res.data.data.software?res.data.data.software:[];//软件著作权
							_this.technologyList=res.data.data.technology?res.data.data.technology:[];//科技型企业资质
							_this.relationship=res.data.data.relationship?res.data.data.relationship:[];//疑似关系
							_this.changeLog=res.data.data.changeLog?res.data.data.changeLog:[];//变迁记录
							if(_this.shareholderlist.length>0){
								setTimeout(()=>{
									var tableheight=document.getElementsByClassName('gdxx-h');
									var sharholderh=document.getElementById('detail_sharholder');
									sharholderh.style.height = tableheight[0].clientHeight+'px'; 
								  _this.shareholderPie('detail_sharholder',_this.shareholderlist); //股东信息柱形图
								},500)
							} 
							
							
						}
					} else {
						_this.tokenfailed(res.data.msg);
					}
				}).catch(function(error) {});
			},
			//查询是否存在CRM库
			isExist(){
				var _this=this; 
				this.$axios.get(this.$api.crm.enterprise.isExist()+"?stockCode="+_this.enterpriseid,{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
					if(res.data.success){ 
						if(res.data.data =='true'){
							_this.addCRMid = res.data.extend.id; 
						} 
					}
					else{ 
							_this.tokenfailed(res.data.msg); 
					} 
				}).catch(function (error) {
					// 请求失败处理 console.log(error);
				});
			},
			//页面最顶部的解锁动态
			pagelockfun(){
				if(this.enterprisedata1.unlockRemainder>0){
					this.unlock=true;
				}else{
					this.bus.$emit('tipspop',{lock:true,type:"permissionNum"});
				} 
			},
			//主营业务字太多
			editfontnum(type){
				var defaultnum=this.defaultmainnum;
				if(type == "main"){
					this.mainfontnum = this.mainfontnum == defaultnum? this.companyinfor.mainBusiness.length:defaultnum;
				}else if (type == "busin"){
					this.businfontnum = this.businfontnum == defaultnum? this.companyinfor.businessScope.length:defaultnum;
				}else if(type == "sum"){
					this.sumfontnum = this.sumfontnum == defaultnum? this.companyinfor.summary.length:defaultnum;
				}else if(type =='team'){
					this.teamfontnum = this.teamfontnum == defaultnum? this.financing[0].team.length:defaultnum;
					// console.log(this.teamfontnum,defaultnum)
				}
			},
			//表格数据太长的隐藏
			contorlpatent(type,islock){
				// console.log(islock);
				// console.log(this.patentlist.length,this.showzhuanlinum);
				if(type == 'zl'){
					if(this.showzhuanlinum<this.patentlist.length){
						this.showzhuanlibtn++;
					}else{ 
						this.showzhuanlibtn=1;
					}
					// if(islock){
					// 	this.showzhuanlinum=this.showzhuanlibtn*20;
					// }else{
						this.showzhuanlinum=this.showzhuanlibtn*100;
					// }
				}else if( type == 'sp'){
					if(this.showsuppliernum<this.supplierInfornum){
						this.showsupplierbtn++;
					}else{ 
						this.showsupplierbtn=1;
					}
					this.showsuppliernum=this.showsupplierbtn*100;
				}else if( type == "cu"){
					if(this.showcustomernum<this.customerInfornum){
						this.showcustomerbtn++;
					}else{ 
						this.showcustomerbtn=1;
					}
					this.showcustomernum=this.showcustomerbtn*100; 
				} 
			},
			//控制企业的投资链文字的形式优化
			controllEnterprisefun(data){
				var companyname=this.companyinfor.title;
				for(var i=0;i<data.length;i++){
					let tds=data[i].investChain; 
					data[i].investChainhtml=tds.split('路径');
					 var proportionnum=data[i].proportion;
						if(proportionnum.indexOf('%')<0){
							data[i].proportion=data[i].proportion*100+'%';
						}
					for(var d=0;d<data[i].investChainhtml.length;d++){
						if(data[i].investChainhtml[d]!=""){
							let ddsttss=data[i].investChainhtml[d];
							ddsttss="<b>路径"+ddsttss;
							var indst=ddsttss.indexOf(companyname);
							data[i].investChainhtml[d]=ddsttss.slice(0, indst) + '</b>' + ddsttss.slice(indst); 
						} 
					}
					
				}  
				this.controllEnterprise=data;
			}, 
			shareholderPie($el,data) {
				var xdata=[],serdata=[];
				for(var i =0;i<data.length;i++){ 
					xdata.push(data[i].name);
					serdata.push(data[i].value);
				}
				var chart = echarts.init(document.getElementById($el));
			var option = {
				title: {
					text: "",
					left: 'center', 
						bottom:10,
					textStyle: { color: '#000', fontSize: 16 }
				},
				tooltip: { 
				}, 
			color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				// legend: {
				//   data: ['Top 10股东持股比例'],
				// 		bottom:10,
				// },
				grid: { x:300, y: 10, x2: 50, y2: 30, show: true, 	borderWidth: 0, },
				label: {
					show: true, position: 'right', valueAnimation: true, color: '#737373', 
				},
				xAxis: {
					type: 'value',
					axisTick: { show: false },
					boundaryGap: [0, 0.01],
					splitLine: {
						show: true
					},
					axisLabel: {fontSize: 13, 	color: '#737373' }
				},
				yAxis: { 
					type: 'category',
					inverse: true,//倒叙
					splitLine: { show: false },
					axisTick: { show: false },
					axisLine: { show: true },
					data:xdata,
					axisLabel: {
						fontSize: 13,
						color: '#737373',
						formatter: function(params) {  //标签太长换行
							var newParamsName = ""; // 最终拼接成的字符串
							var paramsNameNumber = params.length; // 实际标签的个数
							var provideNumber = 22; // 每行能显示的字的个数
							var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
							/**
								* 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
								*/
							// 条件等同于rowNumber>1
							if (paramsNameNumber > provideNumber) {
								/** 循环每一行,p表示行 */
								for (var p = 0; p < rowNumber; p++) {
									var tempStr = ""; // 表示每一次截取的字符串
									var start = p * provideNumber; // 开始截取的位置
									var end = start + provideNumber; // 结束截取的位置
									// 此处特殊处理最后一行的索引值
									if (p == rowNumber - 1) {
										// 最后一次不换行
										tempStr = params.substring(start, paramsNameNumber);
									} else {
										// 每一次拼接字符串并换行
										tempStr = params.substring(start, end) + "\n";
									}
									newParamsName += tempStr; // 最终拼成的字符串
								}
			
							} else {
								// 将旧标签的值赋给新标签
								newParamsName = params;
							}
							//将最终的字符串返回
							return newParamsName
						}  
					}
				},
				series: [{
					name:'',
					data: serdata,
					type: 'bar', 
					label:{ 							//图表顶部显示数据
							normal:{show: true, formatter: '{@score}'+'%' }
					},
				}]
			};
			chart.setOption(option); 
			}, 
			//企业网址跳转
			geturl(url) {  window.open(url); }, 
			download(){  //下载企业报告  
					this.downloadurl=this.$api.download.enterprise.whole()+'?c='+this.enterpriseid+'&t='+btoa(this.userdata.token);
				this.iframeurl =  this.downloadurl; 
				window.open(this.downloadurl,"_blank",);   
				this.iframestus=false; 
				setTimeout(()=>{
				 this.iframestus=true; 
				},60000)
			},  
			//从企业库添加或删除CRM库
			addtoCRM() {
				var _this = this;
				if (_this.addCRMid == 0) {
					this.$axios.get(this.$api.crm.enterprise.addtoCRM() + "?stockCode=" + _this.enterpriseid, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						// console.log("添加到CRM库",res);   
						if (res.data.success) {
							_this.addCRMid = res.data.data.id;
							// console.log('客户id',_this.addCRMid); 
							_this.$message({
								type: 'success',
								message: "已加入项目管理"
							})
						} else {
							_this.tokenfailed(res.data.msg);
						}
					}).catch(function(error) {
						// 请求失败处理 console.log(error);
					});
				} else {
					console.log('移除', _this.addCRMid)
					$.ajax({
						type: "POST",
						url: this.$api.crm.customer.delete(),
						data: {
							id: _this.addCRMid
						},
						headers: {
							AuthToken: this.userdata.token
						},
						success: function(res) {
							console.log(res)
							// console.log('cusid',_this.addCRMid);
							// console.log(res); 
							if (res.success) {
								_this.addCRMid = 0;
								_this.$message({
									type: 'success',
									message: "已移出项目管理"
								})
							}
						}
					})
				}
			},   
			//获取用户信息
			getuserinfor() {
				let dataddd = sessionStorage.getItem('userData') ? sessionStorage.getItem('userData') : localStorage
					.getItem('userData');
				if (typeof(dataddd) == 'object') {
					this.userdata = dataddd;
				} else {
					this.userdata = JSON.parse(dataddd);
				}
			},
			//添加删除收藏
			collectFun() {
				// console.log(this.companyinfor.collectId,this.companyinfor);
				this.listToggleCollect(this.companyinfor, 'acoc');
			},
			//测试title的问题
			testFloorTitle() {
				console.log(document.getElementsByClassName('d-floortitle').length, document.getElementsByClassName(
					'floorlistLi').length)
				for (var i = 0; i < document.getElementsByClassName('d-floortitle').length; i++) {
					console.log(document.getElementsByClassName('d-floortitle')[i], document.getElementsByClassName(
						'floorlistLi')[i]);
				}
			},
			//鼠标滚动监测函数
			handleScroll: function(e) {
				var enflolength = document.getElementsByClassName('ende_floorlistfixed').length;
				// console.log('enflolength1',enflolength)
				if (enflolength < 1) {
					return;
				}
				var sctop = document.documentElement.scrollTop;
				var bartop = document.getElementsByClassName('ende_floorlist')[0].offsetTop;
				// console.log(sctop,bartop);
				if (sctop < bartop) {
					document.getElementsByClassName('ende_floorlistfixed')[0].className = "ende_floorlistfixed";
				} else {
					document.getElementsByClassName('ende_floorlistfixed')[0].className =
						"ende_floorlistfixed fixedbox";
					var lengtsd = document.getElementsByClassName('floorlistLi').length;
					// console.log(lengtsd,document.getElementsByClassName('d-floortitle').length )
					for (var i = 0; i < lengtsd; i++) {
						// console.log(document.getElementsByClassName('d-floortitle')[i],document.getElementsByClassName('d-floortitle')[i+1])
						var top1 = document.getElementsByClassName('d-floortitle')[i].offsetTop - this.barHeight;
						if (i < lengtsd - 1) {
							var top2 = document.getElementsByClassName('d-floortitle')[i + 1].offsetTop - 11 - this
								.barHeight;
							if (top1 > 0 && top2 > 0 && sctop > top1 && sctop < top2) {
								this.floorscroll(i, 'scroll');
							}
						} else if (i == lengtsd - 1) {
							if (top1 > 0 && sctop > top1) {
								this.floorscroll(i, 'scroll');
							}
						}
					};
				}
			},
			//楼层导航
			floorscroll(indexs, type) {
				// console.log(indexs,type);
				var oftop = document.getElementsByClassName('d-floortitle')[indexs].offsetTop - this.barHeight + 6;
				var lengtsd = document.getElementsByClassName('floorlistLi').length;
				// console.log('floorsrcoll',lengtsd);
				for (var i = 0; i < lengtsd; i++) {
					var classNameaf = "floorlistLi";
					if (i == indexs) {
						classNameaf = "floorlistLi current";
					}
					document.getElementsByClassName('floorlistLi')[i].className = classNameaf;
				}
				if (type != 'scroll') {
					// console.log('非',type,oftop);
					window.scrollTo(0, oftop);
				}
				if (type == 'test') {
					this.testFloorTitle();
					console.log(this.riskinfobtn, this.eqpledgeBtn)
				}
			},
		}
	}
</script>

<style>
</style>
